function Notes() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 32 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7647 0H12.2353C9.63631 0 7.52941 2.13198 7.52941 4.7619C7.52941 7.39183 9.63631 9.52381 12.2353 9.52381H19.7647C22.3637 9.52381 24.4706 7.39183 24.4706 4.7619C24.4706 2.13198 22.3637 0 19.7647 0Z"
        fill="#0340FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.2943 3.86883C29.5156 4.30523 32 7.09713 32 10.4762V33.3333C32 37.0152 29.0503 40 25.4118 40H6.58824C2.94965 40 0 37.0152 0 33.3333V10.4762C0 7.09713 2.48439 4.30523 5.70566 3.86883C5.66701 4.16095 5.64706 4.45907 5.64706 4.7619C5.64706 8.4438 8.59671 11.4286 12.2353 11.4286H19.7647C23.4033 11.4286 26.3529 8.4438 26.3529 4.7619C26.3529 4.45907 26.333 4.16095 26.2943 3.86883ZM8.47059 24.7619H23.5294C24.0492 24.7619 24.4706 24.3355 24.4706 23.8095C24.4706 23.2835 24.0492 22.8571 23.5294 22.8571H8.47059C7.95079 22.8571 7.52941 23.2835 7.52941 23.8095C7.52941 24.3355 7.95079 24.7619 8.47059 24.7619ZM23.5294 17.1429H8.47059C7.95079 17.1429 7.52941 16.7165 7.52941 16.1905C7.52941 15.6645 7.95079 15.2381 8.47059 15.2381H23.5294C24.0492 15.2381 24.4706 15.6645 24.4706 16.1905C24.4706 16.7165 24.0492 17.1429 23.5294 17.1429ZM8.47059 32.381H23.5294C24.0492 32.381 24.4706 31.9546 24.4706 31.4286C24.4706 30.9026 24.0492 30.4762 23.5294 30.4762H8.47059C7.95079 30.4762 7.52941 30.9026 7.52941 31.4286C7.52941 31.9546 7.95079 32.381 8.47059 32.381Z"
        fill="#0340FF"
      />
    </svg>
  )
}

function Target() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.4546 9.30441C38.2948 12.7578 40 17.1797 40 22C40 33.0457 31.0457 42 20 42C8.9543 42 0 33.0457 0 22C0 10.9543 8.9543 2 20 2C24.7848 2 29.1772 3.68026 32.6193 6.48292L33.7209 5.38127L34.2444 2.59253C34.4483 1.50692 35.4935 0.792088 36.5791 0.995897C37.6647 1.19971 38.3796 2.24498 38.1758 3.33058L38.0616 3.93844L38.6695 3.82432C39.7551 3.62052 40.8004 4.33535 41.0042 5.42096C41.208 6.50656 40.4932 7.55184 39.4076 7.75564L36.4477 8.31132L35.4546 9.30441ZM29.7722 9.32998C27.0692 7.24214 23.6797 6 20 6C11.1634 6 4 13.1634 4 22C4 30.8366 11.1634 38 20 38C28.8366 38 36 30.8366 36 22C36 18.2848 34.7338 14.8654 32.6093 12.1497L29.7526 15.0065C31.1671 16.9755 32 19.3905 32 22C32 28.6274 26.6274 34 20 34C13.3726 34 8 28.6274 8 22C8 15.3726 13.3726 10 20 10C22.5738 10 24.9584 10.8103 26.9125 12.1897L29.7722 9.32998ZM24.0202 15.082C22.8389 14.394 21.4655 14 20 14C15.5817 14 12 17.5817 12 22C12 26.4183 15.5817 30 20 30C24.4183 30 28 26.4183 28 22C28 20.4983 27.5862 19.0932 26.8665 17.8926L23.8495 20.9095C23.9476 21.2562 24 21.622 24 22C24 24.2091 22.2091 26 20 26C17.7909 26 16 24.2091 16 22C16 19.7909 17.7909 18 20 18C20.3385 18 20.6671 18.042 20.981 18.1212L24.0202 15.082Z"
        fill="#0340FF"
      />
    </svg>
  )
}

function Video() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 59 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2917 0.5H48.0417C53.9937 0.5 58.8333 5.14333 58.8333 10.8889V41.1111C58.8333 46.8567 53.9937 51.5 48.0417 51.5H11.2917C5.33965 51.5 0.5 46.8567 0.5 41.1111V10.8889C0.5 5.14333 5.33965 0.5 11.2917 0.5ZM11.2917 6.16667C8.5452 6.16667 6.33333 8.28881 6.33333 10.8889V41.1111C6.33333 43.7112 8.5452 45.8333 11.2917 45.8333H48.0417C50.7881 45.8333 53 43.7112 53 41.1111V10.8889C53 8.28881 50.7881 6.16667 48.0417 6.16667H11.2917ZM27.3669 39.2996C25.3475 40.9235 22.5321 40.1689 21.402 37.9896C21.0804 37.3693 20.9167 36.6779 20.9167 35.9819V16.0179C20.9167 13.8393 22.5275 11.8333 24.9184 11.8333C25.823 11.8333 26.6803 12.148 27.3669 12.7002L39.78 22.6822C41.3704 23.9612 41.7643 26.2402 40.8478 28.0076C40.5876 28.5094 40.2279 28.9574 39.78 29.3176L27.3669 39.2996ZM26.75 19.5605V32.4394L34.7577 25.9999L26.75 19.5605Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="31.0001"
          y1="-0.50003"
          x2="31.0001"
          y2="50.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2276FF" />
          <stop offset="1" stop-color="#0340FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export { Notes, Target, Video }
